import { notification } from "antd";
import axios from "axios";
import { sessionManager } from '../core/SessionManager';
import api from './api'


let baseUrl = process.env.REACT_APP_API_BASE_URL;


const instance = axios.create({
    timeout: 60000,
    baseURL: baseUrl
})
instance.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'

instance.interceptors.request.use(config => {
    config.headers['Authorization'] = sessionManager.getToken() === null ? '' : 'Bearer ' + sessionManager.getToken()
    return config
}, error => {
    return Promise.reject(error)
})



async function doRequest(requestConfig) {
    requestConfig.headers['Authorization'] = 'Bearer ' + sessionManager.getToken()
    let rs;
    await axios.request(requestConfig).then((rsdata) => {
        rs = rsdata;
    })

    return await Promise.resolve(rs.data.data);
}

instance.interceptors.response.use(response => {
    if (response.data.errcode === '0') {
        return Promise.resolve(response.data.data)
    } else {
        return Promise.reject(response.data.errmsg)
    }
}, error => {
    if (error.response) {
        if (error.response.status === 401) {
            if (sessionManager.getRefreshToken()) {
                const refreshData = { refreshToken: sessionManager.getRefreshToken() }
                const resReqData = axios.post(api.refreshToken, refreshData).then(function (res) {
                    if (res.data.errcode !== '0') {
                        sessionManager.signout();
                        window.location.reload();
                        return;
                    } else {
                        sessionManager.setToken(res.data.data.accessToken)
                        sessionManager.setRefreshToken(res.data.data.refresh_token)
                        let config = error.response.config

                        return doRequest(config);
                    }
                }).catch(function (err) {
                    sessionManager.signout();
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500)
                    return;
                })
                return resReqData;
            } else {
                sessionManager.signout();
                window.location.reload();
                return;
            }
        }
        console.log(error)
        return Promise.reject(error)
    } else {
        return Promise.reject("The request time out, please try again.")
    }
})

export const get = (url, params, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: 'get',
            url,
            params,
            ...config
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const post = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: 'post',
            url,
            data,
            ...config
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const downloadFile = (url, data = {}) => {
    if(url === api.doExport){
        url = baseUrl+url;
    }
    axios({
        url: url,
        method: 'post',
        data,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            'Authorization': sessionManager.getToken() === null ? '' : 'Bearer ' + sessionManager.getToken()
        },
        responseType: 'blob',
    }).then(function (res) {
        const fileName = res.headers['content-disposition'].match(
            /filename=(.*)/
        )[1]
        const blob = new Blob([res.data], { type: res.headers['content-type'] })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(blob, decodeURI(fileName))
        } else {
            const blobURL = window.URL.createObjectURL(blob);

            const tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(fileName))

            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }

            document.body.appendChild(tempLink)

            tempLink.click()

            document.body.removeChild(tempLink);

            window.URL.revokeObjectURL(blobURL)
        }
    }).catch(error => {
        if (error.response) {
            if (error.response.status === 401) {
                if (sessionManager.getRefreshToken()) {
                    const refreshData = { refreshToken: sessionManager.getRefreshToken() }
                    const resReqData = axios.post(api.refreshToken, refreshData).then(function (res) {
                        if (res.data.errcode !== '0') {
                            sessionManager.signout();
                            window.location.reload();
                            return;
                        } else {
                            sessionManager.setToken(res.data.data.accessToken)
                            sessionManager.setRefreshToken(res.data.data.refresh_token)
                            let config = error.response.config
                            downloadFile(config.url, config.data);
                        }
                    }).catch(function (err) {
                        sessionManager.signout();
                        setTimeout(() => {
                            window.location.reload();
                        }, 1500)
                        return;
                    })
                } else {
                    sessionManager.signout();
                    window.location.reload();
                    return;
                }
            }
            console.log(error)
            notification['error']({
                message: error.errmsg,
              });
            return;
        } else {
            notification['error']({
                message: error.errmsg,
              });
            return;
        }
    });

}